import { AnchorNode } from '../anchor';
import { isContainerFirst } from './isContainerFirst';
import { NodeTextNavigation } from './NodeTextNavigation';
import { resolvePathWithOffset } from './resolvePathWithOffset';

export function getSelectionRangeDetail(root: AnchorNode, start: string, end: string) {
    const matchStart = resolvePathWithOffset(root, start);
    if (!matchStart) { return null; }

    const matchEnd = resolvePathWithOffset(root, end);
    if (!matchEnd) { return null; }

    const textStart = new NodeTextNavigation(matchStart.anchor.node).forward(matchStart.offset).domNode();
    const textEnd = new NodeTextNavigation(matchEnd.anchor.node).forward(matchEnd.offset).domNode();

    const offsetStart = new NodeTextNavigation(matchStart.anchor.node).forward(matchStart.offset).countBackwards(textStart);
    const offsetEnd = new NodeTextNavigation(matchEnd.anchor.node).forward(matchEnd.offset).countBackwards(textEnd);

    const isStartToEnd = isContainerFirst(textStart, offsetStart, textEnd, offsetEnd);
    return isStartToEnd
        ? {
            offsetEnd,
            offsetStart,
            textEnd,
            textStart,
        }
        : {
            offsetEnd: offsetStart,
            offsetStart: offsetEnd,
            textEnd: textStart,
            textStart: textEnd,
        };
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/getSelectionRangeDetail.tsx